<template>
  <div id="admin">

    <!-- navigation -->
    <nav-list class="bg-odd2" id="nav-bar"/>

    <!-- tables -->
    <div id="period-details">
      <div id="period-details-scroller" class="padded bg-default">
        <div class="period-selector">
          <select class="input--control">
            <option>2019</option>
            <option>2018</option>
            <option>2017</option>
          </select>
        </div>
        <div v-for="periods in 10" class="period-block">
          <admin-header v-bind:periodnr="periods"/>
          <admin-table />
        </div>
      </div>
    </div>

    <!-- side bar -->
    <aside id="person-details">
      <admin-employee-details />
      <div style="flex: 1;">
      </div>
    </aside>
  </div>
</template>

<script>
  import Loader from '../components/ui/Loader.vue'
  import { userService } from '../services/user.service.js';
  import NavList from '../components/lists/NavList.vue';

  export default {
    name: 'admin-overview',
    components: {
      NavList,
      Loader
    },
    data () {
        return {
            token: JSON.parse(localStorage.getItem('user')).id
        }
    },
  }
</script>